module.exports = __webpack_public_path__ + "static/media/Gelt-back.df847d54.PNG";